import { createTestIds } from '../../utils';

export const selectionCardElements = ['content', 'image', 'label', 'actions'] as const;

export const getSelectionCardTestIds = createTestIds('selection-card', selectionCardElements);
